/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 7ac6369803ed5c0cd8c0799844960d8e */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildsScreenAllListPaginationQueryVariables = {
    count: number;
    cursor?: string | null | undefined;
};
export type GuildsScreenAllListPaginationQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"GuildsScreenAllList_query">;
};
export type GuildsScreenAllListPaginationQuery = {
    readonly response: GuildsScreenAllListPaginationQueryResponse;
    readonly variables: GuildsScreenAllListPaginationQueryVariables;
};



/*
query GuildsScreenAllListPaginationQuery(
  $count: Int! = 12
  $cursor: Cursor
) {
  ...GuildsScreenAllList_query_1G22uz
}

fragment GuildCardNew_guild on Guild {
  rowId
  slugId
  name
  description
  type
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
  ...GuildPrimaryPhotoNew_guild
  backgroundPhoto {
    rowId
    contentType
    id
  }
}

fragment GuildList_guildsConnection on GuildsConnection {
  edges {
    node {
      ...GuildCardNew_guild
      id
    }
    cursor
  }
}

fragment GuildPrimaryPhotoNew_guild on Guild {
  name
  rowId
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment GuildsScreenAllList_query_1G22uz on Query {
  guilds: rankedGuilds(first: $count, after: $cursor) {
    ...GuildList_guildsConnection
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 12,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildsScreenAllListPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          }
        ],
        "kind": "FragmentSpread",
        "name": "GuildsScreenAllList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildsScreenAllListPaginationQuery",
    "selections": [
      {
        "alias": "guilds",
        "args": (v1/*: any*/),
        "concreteType": "GuildsConnection",
        "kind": "LinkedField",
        "name": "rankedGuilds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Guild",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slugId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GuildMembership",
                    "kind": "LinkedField",
                    "name": "myMembership",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "membershipLevel",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UsersConnection",
                    "kind": "LinkedField",
                    "name": "networkMembers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "primaryPhoto",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "backgroundPhoto",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "guilds",
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "GuildsScreenAllList_query_guilds",
        "kind": "LinkedHandle",
        "name": "rankedGuilds"
      }
    ]
  },
  "params": {
    "id": "edf2c57418c1c017ae0dd6d83d360db7fee33537f8d49769abaf3f50a470da00",
    "metadata": {},
    "name": "GuildsScreenAllListPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '475ef6e1d7a7382fcf35550afbb920a1';
export default node;
